package com.yet.tetris.domain.model.game

enum class RotationDirection {
    CLOCKWISE,
    COUNTERCLOCKWISE,
    ONE_EIGHTY,
}
